// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/climb-and-glide-forces.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/climb-and-glide-forces/climb-and-glide-forces.js';

mount([g0]);
